<template>
    <div class="filter-content-entry" data-tab="price">
        <div class="filter-content-entry-mobile-title">
            <a href="#" class="btn btn-rebrand-grey-outline btn-rebrand-xxs px-2 back">{{translate.account.onboard.back}}</a>
            <span class="filter-title">{{translate.home.price}}</span>
            <a href="#" class="btn btn-rebrand-black btn-rebrand-xxs ml-auto px-2"
               @click.prevent="clearAllFilters()">{{translate.home.clearAll}}</a>
        </div>
        <div class="row">
            <div class="col-md-12 my-5 px-4 px-sm-3">
                <vue-slider @change="onFilterUpdated"
                            v-model="priceRange"
                            :min="priceRangeDefault[0]"
                            :max="priceRangeDefault[1]"
                            :interval="1"
                            :silent="true"
                            :tooltip="'always'"
                            :tooltip-placement="'bottom'"
                            :tooltip-formatter="'€{value}'"/>
            </div>
        </div>
    </div>
</template>

<script>
    import debounce from 'debounce';

    const data = () => {
        return {
            store: $store,
            priceRange: [-1, 99999],
            priceRangeDefault: [],
            unSubscribe: null,
            debounceTime: 100,
        }
    };

    function mounted() {
        this.unSubscribe = this.store.subscribe((mutation) => {
            if (mutation.type === 'setFilterOpened'
                && mutation.payload
                && (!Object.keys(this.priceTemp).length)
            ) {
                this.store.commit('setPriceTemp', _.cloneDeep(this.price));
            }
        });
        // this.fetchPriceRange();
    }

    async function fetchPriceRange() {

        const [err, response] = await to(
            api.prices.range()
        );

        if (err) {
            toastr.error(this.translate.home.errorCommon);
        }

        const priceRange = _.get(response, 'data.price_range', []);
        if (priceRange.length === 2) {
            this.onSuccess(priceRange);
        }
    }

    function onSuccess(priceRange) {
        this.priceRangeDefault = priceRange;
        this.priceRange = _.cloneDeep(this.priceRangeDefault);
    }

    function onFilterUpdated(value) {
        this.store.commit('setPriceTemp', value);
    }

    function clearAllFilters() {
        this.store.commit('setPriceTemp', []);
    }

    export default {
        data,
        created() {
            this.onFilterUpdated = debounce((this.onFilterUpdated), this.debounceTime);
        },
        mounted,
        computed: {
            ...mapState([
                'price',
                'priceTemp',
                'translate'
            ]),
        },
        watch: {
            priceTemp(value) {
                this.priceRange = (value.length === 2 ? value : this.priceRangeDefault);
            }
        },
        methods: {
            clearAllFilters,
            fetchPriceRange,
            onSuccess,
            onFilterUpdated,
        },
        beforeDestroy() {
            if (this.unSubscribe) {
                this.unSubscribe();
            }
        },
    }
</script>
